<template>
  <div class="add-plan">
    <el-button
      v-if="role.name==='zeus' || role.name==='marketing_manager'"
      @click="addTraceTokenDialogVisible = true"
      type="success"
      icon="el-icon-plus"
      size="small" class="mb-15">
      {{ $t('add_trace_token') }}
    </el-button>
    <el-dialog
      :visible.sync="addTraceTokenDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('add_trace_token')" top="1vh">
      <el-form
        label-position="top"
        :model="traceToken"
        ref="addTraceToken"
        :rules="rules"
        :disabled="loading">
          <el-form-item
            prop="campaign"
            :label="$t('campaign_name')">
            <el-input v-model="traceToken.campaign" />
          </el-form-item >
          <el-form-item
            prop="trace_token"
            :label="$t('trace_token')">
            <el-input v-model="traceToken.trace_token" />
          </el-form-item >
          <el-form-item
            :label="$t('plan')"
            prop="plan.id">
              <el-select
                v-model="traceToken.plan.id"
                :placeholder="$t('select')" filterable >
                <el-option
                  v-for="plan in plans"
                  :key="plan.id.numberStr"
                  :label="plan.name"
                  :value="plan.id.numberStr">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            :label="`${$t('plan_expiration')} (${$t('day')})`"
            prop="plan.expiration">
            <el-input-number v-model="traceToken.plan.expiration" :min="1"></el-input-number>
          </el-form-item>
          <el-form-item
            prop="expiry"
            :label="`${$t('token_expiration')} (${$t('day')})`">
            <el-input-number v-model="traceToken.expiry" :min="1"></el-input-number>
          </el-form-item >
        <div class="line"></div>
        <el-form-item class="no-margin">
          <el-button
          @click="validateAndSubmitForm('addTraceToken', createTraceToken)"
          :loading="loading" type="primary">
            {{ $t('submit') }}
          </el-button>
          <el-button
          @click="handleClose"
          :loading="loading">
            {{ $t('close') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'plans',
      'role'
    ])
  },
  data () {
    return {
      loading: false,
      addTraceTokenDialogVisible: false,
      traceToken: {
        campaign: undefined,
        trace_token: '',
        plan: {
          id: '',
          expiration: 1
        },
        expiry: 1,
        plans: null
      },
      rules: {
        plan: {
          id: {
            required: true,
            message: this.$i18n.t('field_required')
          },
          expiration: {
            required: true,
            message: this.$i18n.t('field_required')
          }
        },
        trace_token: {
          required: true,
          message: this.$i18n.t('field_required')
        },
        expiry: {
          required: true,
          message: this.$i18n.t('field_required')
        }
      }
    }
  },
  methods: {
    toggleLoading () {
      this.loading = !this.loading
    },
    createTraceToken () {
      const { traceToken } = this
      const { campaign, plan, expiry } = traceToken
      this.toggleLoading()
      this.handleRequest({
        name: '/trace_tokens',
        action: 'create',
        data: {
          campaign: campaign,
          trace_token: traceToken.trace_token,
          plan_remaining: this.convertDaysToSeconds(plan.expiration),
          plan_id: plan.id,
          expiry: this.convertDaysToSeconds(expiry)
        }
      }).then(this.handleUpdateTraceTokens)
        .catch(this.toggleLoading)
    },
    handleClose () {
      this.addTraceTokenDialogVisible = false
      this.$refs.addTraceToken.resetFields()
    },
    handleUpdateTraceTokens () {
      this.$emit('trace-tokens-updated')
      this.displaySuccessMsg('submit_trace_token')
      this.toggleLoading()
      this.handleClose()
    }
  }
}
</script>

<style lang='css'>
</style>
